module.exports = import("/native/importMetaResolve.mjs");;